import { TextField } from '@mui/material';
import { NumericFormatDecimal, useCurrency } from '@procureai/ui-mui';
import Decimal from 'decimal.js';
import { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { useFormFieldErrorTranslation } from '~/hooks';

interface IntakeBudgetFormProps {
  disabled?: boolean;
}

export const IntakeBudgetForm = ({ disabled }: IntakeBudgetFormProps) => {
  const { errorToHelperText } = useFormFieldErrorTranslation();
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeBudgetStep' });
  const { symbol } = useCurrency();
  const InputComponent = useMemo(() => NumericFormatDecimal({ decimalScale: 2, suffix: symbol }), [symbol]);

  return (
    <Controller
      name="budget"
      render={({ field, fieldState: { error } }) => {
        return (
          <TextField
            {...field}
            variant="standard"
            value={!field.value || isNaN(field.value) ? null : new Decimal(field.value).toNumber()}
            helperText={errorToHelperText(error)}
            fullWidth
            disabled={disabled || field.disabled}
            onChange={(event) => {
              const output = parseFloat(event.target.value);
              const val = isNaN(output) ? null : output;
              field.onChange(val);
            }}
            label={t('budget.label')}
            error={!!error}
            slotProps={{
              input: {
                inputComponent: InputComponent as any,
              },

              inputLabel: { shrink: true },
            }}
          />
        );
      }}
    />
  );
};
